<template>
    <div v-if="productos.length > 0">
        <div class="container">
            <h3>Visto recientemente</h3>
        </div>
        <div class="series-contenedor">
            <div class="row visto-reciente">

                <div class="col-5" v-for="producto in productos">
                        <div class="series text-center">
                    <router-link :to="{ name: 'producto', params: { slug: producto.slug } }" class="text-decoration-none">
                            <img :src="'/storage/'+producto.imagenes[0]" class="imagen-producto">
                            <p class="color-red mt-3 mb-0">{{producto.nombre}}</p>
                    </router-link>
                        </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            productos: [],
        };
    },
    methods: {},
    mounted: function () {
        this.$store
        .dispatch("getRecientes")
        .then(response => {
            this.productos = response.data;
        })
        .catch(error => {
            this.errors = error.response.data;
        });
    }
};
</script>
